import axios from "axios"
import { API_TIMEOUT_MS } from "constants/apiTimeout"
import {
  buildSignedGetHeaders,
  resolvePublicLanguageHeader,
} from "helpers/publicApiHelper"
import { normalizePublicPagePayload } from "pages/Public/utils/publicPageUtils"

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1/"

export const fetchPublicPageContentByTenantUuid = async ({
  tenantUuid,
  type,
  appType = "customer",
}) => {
  const headers = await buildSignedGetHeaders({
    "Accept-Language": resolvePublicLanguageHeader(),
  })

  const response = await axios.get(
    `${API_URL}public/page-content/${tenantUuid}/${type}`,
    {
      params: { appType },
      timeout: API_TIMEOUT_MS,
      headers,
    }
  )

  const payload = response?.data
  if (payload?.status && payload?.data) {
    return normalizePublicPagePayload(payload.data)
  }

  throw new Error(payload?.msg || payload?.message || "Unable to load page content")
}

export const fetchTenantPublicInfo = async token => {
  const headers = await buildSignedGetHeaders({
    Authorization: token,
    "Accept-Language": resolvePublicLanguageHeader(),
    "X-Tenant-Id":
      localStorage.getItem("TENANT_ID") ||
      sessionStorage.getItem("TENANT_ID") ||
      localStorage.getItem("tenantId"),
  })

  const response = await axios.get(`${API_URL}admin/tenants/public-info`, {
    timeout: API_TIMEOUT_MS,
    headers,
  })

  const payload = response?.data
  if (payload?.status && payload?.data) {
    return payload.data
  }

  throw new Error(payload?.msg || payload?.message || "Unable to load tenant public info")
}
